import {ModelBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class TargetMarketManagementRole extends ModelBase {
      targetMarketManagementRoleId: number = 0
      targetMarketId: number = 0
      managementSubRoleId: number = 0
}